module.exports = __webpack_public_path__ + "img/video-player/comment_stroke_hover-321190e362cbd8c85a949630d6b3cb46.svg";